import { useEffect, useState } from "react";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Header } from "./Header";
import { Footer } from "./Footer";

export const BOOK_API = `${process.env.REACT_APP_BACKEND_URL}/api/app/public/booking`;
const WD = ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."];

export const BookingLayout = ({ title, eyebrow, children, testId }) => (
  <div data-testid={testId}>
    <Header />
    <div className="bg-cs-navy pb-12 pt-28 md:pb-16 md:pt-36">
      <div className="mx-auto max-w-3xl px-5 sm:px-8">
        <Link to="/#rangement" className="nav-link inline-flex items-center gap-2 text-sm font-semibold text-white/70"><ArrowLeft className="h-4 w-4" /> Rangement à domicile</Link>
        <span className="eyebrow mt-6 !flex !text-cs-yellow">{eyebrow}</span>
        <h1 className="mt-3 font-display text-4xl font-extrabold tracking-tighter text-white sm:text-5xl">{title}</h1>
      </div>
    </div>
    <main className="bg-cs-grey py-10 md:py-16"><div className="mx-auto max-w-3xl px-5 sm:px-8">{children}</div></main>
    <Footer />
  </div>
);

// Date strip + slot grid. onPick({date, time}).
export const SlotPicker = ({ value, onPick }) => {
  const [days, setDays] = useState(null);
  const [day, setDay] = useState(value?.date || null);
  useEffect(() => {
    axios.get(`${BOOK_API}/slots`, { params: { days: 31 } }).then((r) => {
      setDays(r.data);
      if (!day) setDay(r.data.days.find((d) => d.slots.length)?.date || null);
    }).catch(() => setDays({ days: [], enabled: false }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (!days) return <Loader2 className="h-6 w-6 animate-spin text-cs-navy" />;
  const open = days.days.filter((d) => d.slots.length);
  if (!days.enabled || !open.length) return <p className="rounded-xl bg-white p-5 text-cs-ink/80" data-testid="booking-no-slots">Aucun créneau disponible en ligne pour le moment. Laissez-nous vos coordonnées via le <Link to="/#devis" className="font-bold underline">formulaire</Link>, nous vous rappelons.</p>;
  const cur = days.days.find((d) => d.date === day);
  return (
    <div data-testid="booking-slot-picker">
      <div className="-mx-1 flex gap-2 overflow-x-auto px-1 pb-2" data-testid="booking-days">
        {open.map((d) => {
          const dt = new Date(`${d.date}T12:00:00`);
          return (
            <button key={d.date} type="button" onClick={() => setDay(d.date)} data-testid={`booking-day-${d.date}`}
              className={`flex min-w-[68px] flex-col items-center rounded-xl border px-3 py-2.5 transition-colors ${d.date === day ? "border-cs-navy bg-cs-navy text-white" : "border-cs-navy/15 bg-white text-cs-navy"}`}>
              <span className="text-xs font-semibold uppercase">{WD[dt.getDay()]}</span>
              <span className="font-display text-xl font-extrabold">{dt.getDate()}</span>
              <span className="text-[11px]">{dt.toLocaleDateString("fr-CH", { month: "short" })}</span>
            </button>
          );
        })}
      </div>
      {cur && (
        <div className="mt-4 grid grid-cols-3 gap-2 sm:grid-cols-5" data-testid="booking-slots">
          {cur.slots.map((t) => (
            <button key={t} type="button" onClick={() => onPick({ date: cur.date, time: t })} data-testid={`booking-slot-${t.replace(":", "")}`}
              className={`rounded-lg border py-3 font-bold transition-colors ${value?.date === cur.date && value?.time === t ? "border-cs-yellow bg-cs-yellow text-cs-navy" : "border-cs-navy/15 bg-white text-cs-navy hover:border-cs-navy"}`}>{t}</button>
          ))}
        </div>
      )}
      <p className="mt-3 text-xs text-cs-ink/60">Durée de la visite : environ {days.duration} min · gratuite et sans engagement.</p>
    </div>
  );
};

export const fmtSlot = (s) => s && `${new Date(`${s.date}T12:00:00`).toLocaleDateString("fr-CH", { weekday: "long", day: "numeric", month: "long" })} à ${s.time}`;
